(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-summary-bar"] && !Shopify.designMode) return;
  try {
    
  class CartSummaryBar extends HTMLElement {
    updateFromCart(cart) {
      if (!cart) {
        return;
      }

      const unitsEl = this.querySelector('[data-cart-summary-units]');
      const stylesEl = this.querySelector('[data-cart-summary-styles]');
      const itemCount = cart.item_count || 0;
      const stylesCount = cart.items ? cart.items.length : 0;

      if (unitsEl) {
        unitsEl.textContent = String(itemCount);
      }
      if (stylesEl) {
        stylesEl.textContent = String(stylesCount);
      }

      this.toggleAttribute('hidden', itemCount === 0);
    }

    static updateAllFromCart(cart) {
      document.querySelectorAll('cart-summary-bar').forEach(function (bar) {
        bar.updateFromCart(cart);
      });
    }

    static async refreshAll() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
          return;
        }
        const cart = await response.json();
        CartSummaryBar.updateAllFromCart(cart);
      } catch (error) {
        console.error('Cart summary bar could not be updated:', error);
      }
    }
  }

  function installCartSummaryBarHooks() {
    if (window.__cartSummaryBarHooksInstalled) {
      return;
    }
    window.__cartSummaryBarHooksInstalled = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        const cartData = payload && payload.cartData;
        if (cartData && typeof cartData.item_count === 'number') {
          CartSummaryBar.updateAllFromCart(cartData);
        } else {
          void CartSummaryBar.refreshAll();
        }
      });
    }

    if (typeof updateCartCounters === 'function') {
      const originalUpdateCartCounters = updateCartCounters;
      window.updateCartCounters = async function () {
        await originalUpdateCartCounters.apply(this, arguments);
        await CartSummaryBar.refreshAll();
      };
    }
  }

  if (!customElements.get('cart-summary-bar')) {
    customElements.define('cart-summary-bar', CartSummaryBar);
  }

  installCartSummaryBarHooks();

  } catch(e) { console.error(e); }
})();
})();
